// export const Base_URL = 'https:localhost:44370/api/HIS/';
// export const Base_URL = 'http://192.168.15.3/Test_HIS/api/Insurance/';
// export const Base_URL = 'http://192.168.15.3/Test_HISNew/api/Laboratory/';

export const Base_URL = 'https://www.relainstitute.in/relalive/api/Laboratory/';
export const SEARCH_API = Base_URL + 'lab-papsmear-list';
export const SEND_API = Base_URL + 'pap-smear-sms-update';
